module.exports = __webpack_public_path__ + "static/media/swagga.02b8fdf1.png";